import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import OnboardingPage from './pages/OnboardingPage';
import QuizPage from './pages/QuizPage';
import WaitingPage from './pages/WaitingPage';
import ResultsPage from './pages/ResultsPage';
import StatsPage from './pages/StatsPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPage from './pages/PrivacyPage';
import AffiliatePage from './pages/AffiliatePage';
import SharePage from './pages/SharePage';
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';
import MockSharePage from './pages/MockSharePage';
import MockQuizPage from './pages/MockQuizPage';
import MockWaitingPage from './pages/MockWaitingPage';
import MockResultsPage from './pages/MockResultsPage';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public SEO pages (indexable; prerendered where applicable) */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/affiliates" element={<AffiliatePage />} />
      <Route path="/blog" element={<BlogListPage />} />
      <Route path="/blog/category/:categoryId" element={<BlogListPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />

      {/* App-flow routes (session/private UX, client-rendered, noindex) */}
      <Route path="/start" element={<OnboardingPage />} />
      <Route path="/share/:sessionId" element={<SharePage />} />
      <Route path="/quiz/:sessionId/:partner" element={<QuizPage />} />
      <Route path="/waiting/:sessionId/:partner" element={<WaitingPage />} />
      <Route path="/results/:sessionId" element={<ResultsPage />} />

      {/* Dev-only routes: internal tools and mock/QC pages. Tree-shaken from
          production builds via import.meta.env.DEV → `false`. */}
      {import.meta.env.DEV && (
        <>
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/mock/share" element={<MockSharePage />} />
          <Route path="/mock/quiz" element={<MockQuizPage />} />
          <Route path="/mock/waiting" element={<MockWaitingPage />} />
          <Route path="/mock/results" element={<MockResultsPage />} />
        </>
      )}

      {/* Fallback */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
